module.exports = __webpack_public_path__ + "img/download.166adde5.webp";